module.exports = __webpack_public_path__ + "static/Ultra_Play-3c765e54a54f23860af8c069659de7c8.jpg";